module.exports = __webpack_public_path__ + "static/img/landing-screen-2.c48f2ac.svg";